import React, { useEffect, useRef, useState } from 'react'
import { ApiService, ModalForAll } from '../../components'
import Select, { components } from 'react-select';
import { toast } from "react-toastify";

import LockIcon from '@mui/icons-material/Lock';
import PublicIcon from '@mui/icons-material/Public';
import PeopleIcon from '@mui/icons-material/People';
import MoodIcon from '@mui/icons-material/Mood';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Picker from '@emoji-mart/react';
import data_emoticons from '@emoji-mart/data';
import ImageIcon from '@mui/icons-material/Image';
import { ImagenesGlobal } from './ImagenesGlobal';
import AddIcon from '@mui/icons-material/Add';
// import CloseIcon from '@mui/icons-material/Close';
import CloseIcon from '@mui/icons-material/Cancel';
import ButtonLoader from './ButtonLoader';
import CallApi from '../../data/CallApi';
import DinamicTarea from './DinamicTarea';

const iconStyle = { color: 'var(--border-color)', fontSize: '15px', marginRight: '5px' };

const selectorIcons = {
    all: <PublicIcon style={iconStyle} />,
    private: <LockIcon style={iconStyle} />,
    users: <PeopleIcon style={iconStyle} />,
}

const UpgradePublication = ({
    myName = 'Cargando...',
    showAll = false,
    myProfile = null,
    modalState = false,
    setModalState = (() => { }),
    its_add = true,
    loadData = {},
    loadIMG = (() => { }),
    upgradePublication = (() => { }),
    urlRequest = 'no_direction',
}) => {
    const [dataPost, setDataPost] = useState(its_add ? {
        img_list: [],
        description: '',
        use_whatsapp: false,
        privacy: 'all',
    } : loadData);

    const [stateEmoticons, setStateEmoticons] = useState(false);
    const [stateUpload, setStateUpload] = useState(false);

    const optionsSelect = [
        {
            value: 'all',
            label: 'Público',
            name: 'public',
        },
        {
            value: 'private',
            label: 'Solo yo',
            name: 'private',
        },
        {
            value: 'users',
            label: 'Usuarios registrados',
            name: 'users',
        },
    ];

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            color: 'var(--color-placeholder)',
            fontSize: '12px',        // tamaño de texto del control
            padding: '0',            // quita el padding interno del control
            border: '1px solid var(--color-placeholder)',// borde personalizado
            boxShadow: 'none',       // quita la sombra cuando está enfocado
            minHeight: '32px',       // ajusta altura mínima
            '&:hover': {
                borderColor: '#999',
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0 8px',        // ajusta el espacio interno del texto seleccionado
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            color: 'var(--color-placeholder)',
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: '12px',        // tamaño de texto del valor seleccionado
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: '12px',        // tamaño de texto de las opciones
            padding: '8px',     // puedes ajustar o quitar padding aquí
            backgroundColor: state.isFocused
                ? '#eee'
                : state.isSelected
                    ? '#ddd'
                    : 'white',
            color: 'var(--color-placeholder)',
        }),
        menu: (provided) => ({ //Este es el contenedor principal
            ...provided,
            marginTop: 0,
            padding: '0px',
            border: '1px solid #ccc',
            color: 'var(--color-placeholder)',
            zIndex: 2,
        }),
    };

    const CustomOption = (props) => (
        <components.Option {...props}>
            <div style={{ display: 'flex', alignItems: 'center', color: 'var(--border-color)' }}>
                {selectorIcons[props.data.value]}
                {props.data.label}
            </div>
        </components.Option>
    );

    const CustomSingleValue = (props) => (
        <components.SingleValue {...props}>
            <div style={{ display: 'flex', alignItems: 'center', color: 'var(--border-color)' }}>
                {selectorIcons[props.data.value]}
                {props.data.label}
            </div>
        </components.SingleValue>
    );

    const positionCaret = useRef(0);
    const filesInput = useRef(null);

    const addImage = (event, its_drop = false) => {
        let listFiles;

        if (stateDrag) setStateDrag(false);
        if (!its_drop) {
            event.preventDefault();
            if (!event.target?.files) return;
            listFiles = Array.from(event.target.files ?? []);
        } else {
            listFiles = Array.from(event ?? []);
        }

        let contador = (dataPost?.img_list ?? []).length ?? 0;
        const newFiles = [];

        for (let index = 0; index < listFiles.length; index++) {
            const file = listFiles[index];
            const extension = file.name.split(".").pop()?.toLowerCase();

            const isValidMime = ["image/png", "image/jpg", "image/jpeg"].includes(file?.type);
            const isValidExtension = ["png", "jpg", "jpeg"].includes(extension);

            if (isValidMime && isValidExtension) contador++;
            else continue;

            if (contador > 9) break;

            const urlTempImg = URL.createObjectURL(file);

            if (file) {
                newFiles.push({
                    file: file,
                    temporalImg: urlTempImg
                }); // Guardamos el archivo como File (binario)
            }
        }

        setDataPost((current_val) => {
            let currentObject = { ...current_val };
            const currentFiles = currentObject?.img_list ?? [];

            currentObject = {
                ...currentObject,
                img_list: currentFiles.concat(newFiles).slice(0, 9)
            };

            return currentObject;
        })
    };

    function removeImg(event, position) {
        event.preventDefault();
        event.stopPropagation();

        setDataPost((current_val) => {
            let currentObject = { ...current_val };
            const currentFiles = currentObject?.img_list ?? [];

            currentObject = {
                ...currentObject,
                img_list: Array.from(currentFiles ?? []).filter((url, index) => index != position)
            };

            return currentObject;
        });
    }

    const [stateDrag, setStateDrag] = useState(false);
    const dragIndex = useRef(null);

    const handleTouchStart = (index) => {
        dragIndex.current = index;
    };

    const handleTouchMove = (e) => {
        e.preventDefault();
    };

    const handleTouchEnd = (e) => {
        const touch = e.changedTouches[0];
        const element = document.elementFromPoint(touch.clientX, touch.clientY);
        if (!element) return;

        // 🔥 Busca el contenedor padre con data-index (no el <img>)
        const parent = element.closest("[data-index]");
        if (!parent) return;

        const dropIndex = parseInt(parent.getAttribute("data-index"));
        if (isNaN(dropIndex) || dropIndex === dragIndex.current) return;

        setDataPost((current_val) => {
            let currentObject = { ...current_val };
            const currentFiles = currentObject?.img_list ?? [];

            [currentFiles[dragIndex.current], currentFiles[dropIndex]] = [
                currentFiles[dropIndex],
                currentFiles[dragIndex.current],
            ];

            currentObject = {
                ...currentObject,
                img_list: currentFiles
            };

            return currentObject;
        });

        dragIndex.current = null;
    };

    const handleDragStart = (index) => dragIndex.current = index;

    const handleDragOver = (e) => e.preventDefault();

    const handleDrop = (index) => {
        if (dragIndex.current === null || dragIndex.current === index) return;

        setDataPost((current_val) => {
            let currentObject = { ...current_val };
            const currentFiles = currentObject?.img_list ?? [];

            [currentFiles[dragIndex.current], currentFiles[index]] = [
                currentFiles[index],
                currentFiles[dragIndex.current],
            ];

            currentObject = {
                ...currentObject,
                img_list: currentFiles
            };

            return currentObject;
        });

        dragIndex.current = null;
    };

    async function saveChanges() {
        const privacy_vals = {
            all: 3,
            private: 0,
            users: 1,
        };

        let body_request = {
            description: String(dataPost?.description ?? ""),
            visibility: privacy_vals[(dataPost?.privacy ?? "all")],
            reference: dataPost?.use_whatsapp ? 1 : 0,
            arrayFile: [],

        };

        if (body_request.arrayFile.length == 0 && body_request.description.length == 0) return toast.info("Agrega una imagen o una descripción para publicar");

        setStateUpload(true);

        if ((dataPost?.img_list ?? []).length > 0) {
            for (let i = 0; i < (dataPost?.img_list ?? []).length; i++) {
                const image = dataPost?.img_list[i];

                if (typeof image == 'string') {
                    body_request.arrayFile.push(image);
                    continue;
                }

                if (typeof image?.img_loaded == 'string') {
                    body_request.arrayFile.push(image?.img_loaded);
                    continue;
                }

                const convert_image = new FormData();
                convert_image.append("file", image.file);

                const upload_img = await CallApi({
                    url: 'api/upload/file',
                    method: 'POST',
                    body: convert_image,
                    its_json: false,
                });

                body_request.arrayFile.push(upload_img?.url ?? null);
                setDataPost((current_data) => {
                    const copyData = { ...current_data };
                    const img_list = copyData?.img_list;

                    img_list[i] = {
                        ...img_list[i],
                        img_loaded: upload_img?.url,
                    };

                    return {
                        ...copyData,
                        img_list: img_list
                    };
                });
            }
        }
        // 

        const resultPost = await CallApi({
            url: urlRequest,
            method: its_add ? 'POST' : 'PUT',
            body: body_request,
        });

        setStateUpload(false);

        if (resultPost != null) {
            setDataPost({
                img_list: [],
                description: '',
                use_whatsapp: false,
                privacy: 'all',
            });
            setModalState(false);

            // if (its_add) {
            //     upgradePublication((current_val) => {
            //         const copyVal = [...current_val];
            //         copyVal.unshift(resultPost?.publication ?? {});
            //         return copyVal;
            //     });
            // }
        }
    }

    function setCaret(value = 0) {
        positionCaret.current = value;
    }

    return (
        <ModalForAll
            stateModal={modalState}
            className='modal-new-post'
            setStateModal={setModalState}
            iconSize='30px'
            iconType='back'
            iconColor='var(--color-white)'
            styleButton={
                {
                    backgroundColor: 'transparent',
                    right: '98%',
                    transform: 'translateX(100%)'
                }}
        >
            {
                stateEmoticons && (
                    <div style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        width: '100%',
                        height: '100%',
                        zIndex: 3
                    }} onClick={() => setStateEmoticons(false)}></div>
                )
            }

            <div className='header-title bgc-hosming-theme'>
                <h3 className='color-white h3-size'>{its_add ? 'Crear' : 'Editar'} Publicación</h3>
            </div>

            <div className='mnp-body'>
                <div className='mnpb-1 mnpb-desktop'
                    onDrop={(event) => {
                        event.preventDefault();
                        event.stopPropagation();

                        if (event.dataTransfer.types.length == 1 && event.dataTransfer.types[0] == "Files") {
                            let newFiles = event.dataTransfer.files;

                            addImage(newFiles, true);
                            setStateDrag(false);
                        }
                    }}
                    onDragOver={(event) => {
                        event.preventDefault();
                        event.stopPropagation();

                        if (event.dataTransfer.types.length == 1 && event.dataTransfer.types[0] == "Files") setStateDrag(true);
                    }}
                    onDragLeave={(event) => {
                        event.preventDefault();
                        event.stopPropagation();

                        setStateDrag(false);
                    }}
                >
                    <div style={{ backgroundColor: stateDrag ? 'rgba(255, 255, 255,0.3)' : 'var(--color-white)' }}>
                        {
                            (dataPost?.img_list ?? []).length > 0 ? (
                                <div
                                    className='collection-images'
                                >
                                    {
                                        dataPost?.img_list.map((obj, index) => (
                                            <div className='shadow-lvl4'
                                                key={'drag-img' + index}
                                                draggable
                                                data-index={index}
                                                onDragStart={() => handleDragStart(index)}
                                                onDragOver={handleDragOver}
                                                onDrop={() => handleDrop(index)}
                                                onTouchStart={() => handleTouchStart(index)}
                                                onTouchMove={handleTouchMove}
                                                onTouchEnd={handleTouchEnd}
                                                style={{
                                                    position: "relative",
                                                    touchAction: "none",
                                                    WebkitUserSelect: "none",
                                                }}
                                            >
                                                <button className='default-buttons-animation' onClick={(event) => removeImg(event, index)}>
                                                    <CloseIcon style={{ fontSize: '30px', color: 'var(--empresa-color)' }} />
                                                </button>
                                                <ImagenesGlobal url={obj} type='picture' loadImageS={loadIMG} />
                                            </div>
                                        ))
                                    }
                                    {
                                        dataPost.img_list.length < 9 && (
                                            <div className='shadow-lvl4' onClick={() => filesInput.current && filesInput.current.click()}>
                                                <span style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <AddIcon style={{ fontSize: '50px', color: 'var(--color-placeholder)' }} />
                                                </span>
                                            </div>
                                        )
                                    }
                                </div>
                            ) : (
                                <span onClick={() => filesInput.current && filesInput.current.click()}>
                                    <ImageIcon style={{ color: 'var(--color-placeholder)', fontSize: '35px' }} />
                                    {stateDrag ? 'Arrastra tus fotos aquí...' : "Agregar Foto"}
                                </span>
                            )
                        }
                    </div>

                    <input
                        hidden
                        ref={filesInput}
                        type='file'
                        multiple
                        accept='.jpg, .jpeg, .png'
                        onChange={addImage}
                    />
                </div>

                <div className='mnpb-2'>
                    <div className='mnpb-2' style={{ padding: '0px' }}>
                        <div className='mnpb-head'>
                            {myProfile}
                            <span className="normal-black text-bold">{myName}</span>
                            <Select
                                options={!showAll ? optionsSelect.filter((data) => data.value != 'private') : optionsSelect}
                                styles={customStyles}
                                value={optionsSelect.find((obj) => obj.value == (dataPost?.privacy ?? 'all'))}
                                components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
                                onChange={(event) => setDataPost((current_val) => ({ ...current_val, privacy: event.value }))}
                            />
                        </div>

                        <div className='mnpb-body'>
                            <button className='default-buttons-animation'
                                style={{ height: 'min-content', position: 'relative' }}
                                onClick={() => setStateEmoticons(current_val => !current_val)}
                            >
                                <MoodIcon style={{ color: 'var(--border-color)', fontSize: '30px' }} />
                            </button>

                            <div className='container-picker' style={{ display: stateEmoticons ? 'block' : 'none' }}>
                                <Picker
                                    data={data_emoticons}
                                    previewPosition="none"
                                    locale="es"
                                    onEmojiSelect={
                                        (e) => {
                                            setDataPost((current_val) => {
                                                const descriptionString = String(current_val?.description ?? '');

                                                const chars = Array.from(descriptionString);
                                                chars.splice(positionCaret.current, 0, e.native);
                                                const newDescription = chars.join('');

                                                positionCaret.current = positionCaret.current + 1;
                                                
                                                return {
                                                    ...current_val,
                                                    description: newDescription
                                                };
                                            });
                                        }
                                    }
                                />
                            </div>

                            {
                                <DinamicTarea
                                    valueT={dataPost?.description}
                                    className='text-size'
                                    setValue={setDataPost}
                                    field={'description'}
                                    style={{ backgroundColor: 'transparent' }}
                                    setCaret={setCaret}
                                />
                            }
                        </div>
                    </div>

                    <div className='mnpb-1 mnpb-mobile'>
                        <div>
                            {
                                (dataPost?.img_list ?? []).length > 0 ? (
                                    <div
                                        className='collection-images'
                                    >
                                        {
                                            dataPost?.img_list.map((obj, index) => (
                                                <div className='shadow-lvl4'
                                                    key={'drag-img' + index}
                                                    draggable
                                                    data-index={index}
                                                    onDragStart={() => handleDragStart(index)}
                                                    onDragOver={handleDragOver}
                                                    onDrop={() => handleDrop(index)}
                                                    onTouchStart={() => handleTouchStart(index)}
                                                    onTouchMove={handleTouchMove}
                                                    onTouchEnd={handleTouchEnd}
                                                    style={{
                                                        position: "relative",
                                                        touchAction: "none",
                                                        WebkitUserSelect: "none",
                                                    }}
                                                >
                                                    <button className='default-buttons-animation' onClick={(event) => removeImg(event, index)}>
                                                        <CloseIcon style={{ fontSize: '30px', color: 'var(--empresa-color)' }} />
                                                    </button>
                                                    <span style={{ position: 'absolute', width: '100%', height: '100%' }}>

                                                    </span>
                                                    <ImagenesGlobal url={obj} type='picture' loadImageS={loadIMG} />
                                                </div>
                                            ))
                                        }
                                        {
                                            dataPost.img_list.length < 9 && (
                                                <div className='shadow-lvl4' onClick={() => filesInput.current && filesInput.current.click()}>
                                                    <span style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <AddIcon style={{ fontSize: '50px', color: 'var(--color-placeholder)' }} />
                                                    </span>
                                                </div>
                                            )
                                        }
                                    </div>
                                ) : (
                                    <span onClick={() => filesInput.current && filesInput.current.click()} style={{ padding: '15px' }}>
                                        <ImageIcon style={{ color: 'var(--color-placeholder)', fontSize: '35px' }} />
                                        {stateDrag ? 'Arrastra tus fotos aquí...' : "Agregar Foto"}
                                    </span>
                                )
                            }
                        </div>

                        <input
                            hidden
                            ref={filesInput}
                            type='file'
                            multiple
                            accept='.jpg, .jpeg, .png'
                            onChange={addImage}
                        />
                    </div>

                    <div className='mnbp-end'>
                        <div>
                            <span className='text-size' style={{ fontWeight: 100 }}>
                                <WhatsAppIcon style={{ color: 'var(--color-whatsapp)', fontSize: '20px', marginRight: '5px' }} />
                                Agregar Whatsapp
                            </span>

                            <div className='container-check'>
                                <button className='default-buttons' onClick={() => setDataPost((current_val) => ({ ...current_val, use_whatsapp: false }))}>
                                    NO
                                </button>

                                <button className='default-buttons' onClick={() => setDataPost((current_val) => ({ ...current_val, use_whatsapp: true }))}>
                                    SI
                                </button>

                                <span style={{ transform: `translateX(${dataPost?.use_whatsapp ? '200%' : '100%'})` }}>

                                </span>
                            </div>
                        </div>

                        <div>
                            <ButtonLoader className='default-buttons-animation' type='button' onClick={saveChanges} state_progress={stateUpload}>
                                Publicar
                            </ButtonLoader>
                        </div>
                    </div>
                </div>
            </div>
        </ModalForAll >
    )
}

export default UpgradePublication